import PropTypes from 'prop-types';
import { forwardRef } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
// routes
import { RouterLink } from 'src/routes/components';

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx, ...other }, ref) => {
  const theme = useTheme();

  const PRIMARY_LIGHT = theme.palette.primary.light;

  const PRIMARY_MAIN = theme.palette.primary.main;

  const PRIMARY_DARK = theme.palette.primary.dark;

  // OR using local (public folder)
  // -------------------------------------------------------
  // const logo = (
  //   <Box
  //     component="img"
  //     src="/logo/logo_single.svg" => your path
  //     sx={{ width: 40, height: 40, cursor: 'pointer', ...sx }}
  //   />
  // );

  const logo = (
    <Box
      ref={ref}
      component="div"
      sx={{
        width: 40,
        height: 40,
        display: 'inline-flex',
        ...sx,
      }}
      {...other}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 320.000000 320.000000">
        
      <g><path  fill="#000d50" d="M 156.5,2.5 C 218.839,3.57024 266.005,30.5702 298,83.5C 323.613,134 323.946,184.667 299,235.5C 264.261,293.792 212.761,320.959 144.5,317C 85.9221,309.31 43.4221,279.143 17,226.5C -8.44758,163.286 0.552418,105.62 44,53.5C 74.7105,21.5402 112.21,4.54023 156.5,2.5 Z"/></g>
      <g><path  fill="#e5542e" d="M 151.5,124.5 C 145.642,124.822 139.975,124.489 134.5,123.5C 152.632,105.868 170.632,88.0351 188.5,70C 196.552,65.9053 203.385,67.4053 209,74.5C 211.185,79.9868 210.851,85.3201 208,90.5C 196.833,101.667 185.667,112.833 174.5,124C 166.841,124.5 159.174,124.666 151.5,124.5 Z"/></g>
      <g><path  fill="#929825" d="M 222.5,124.5 C 209.323,124.829 196.323,124.495 183.5,123.5C 201.692,104.141 220.692,85.6413 240.5,68C 247.735,66.3668 253.569,68.5334 258,74.5C 260.185,79.9868 259.851,85.3201 257,90.5C 245.632,102.035 234.132,113.369 222.5,124.5 Z"/></g>
      <g><path  fill="#0153a1" d="M 123.5,131.5 C 123.565,131.062 123.399,130.728 123,130.5C 104.63,147.706 86.1299,164.706 67.5,181.5C 66.3082,159.237 73.1416,139.904 88,123.5C 101.561,109.27 115.728,95.77 130.5,83C 141.661,80.7219 147.994,85.0552 149.5,96C 149.733,99.4589 148.899,102.626 147,105.5C 138.905,114.086 131.072,122.753 123.5,131.5 Z"/></g>
      <g><path  fill="#71303f" d="M 134.5,123.5 C 139.975,124.489 145.642,124.822 151.5,124.5C 145.654,125.817 139.654,125.817 133.5,124.5C 133.624,123.893 133.957,123.56 134.5,123.5 Z"/></g>
      <g><path  fill="#3f473e" d="M 183.5,123.5 C 196.323,124.495 209.323,124.829 222.5,124.5C 209.327,125.825 195.994,125.825 182.5,124.5C 182.624,123.893 182.957,123.56 183.5,123.5 Z"/></g>
      <g><path  fill="#9a3358" d="M 215.5,132.5 C 207.5,132.5 199.5,132.5 191.5,132.5C 191.5,136.5 191.5,140.5 191.5,144.5C 190.515,140.366 190.182,136.032 190.5,131.5C 199.017,131.174 207.35,131.507 215.5,132.5 Z"/></g>
      <g><path  fill="#fdfdfd" d="M 123.5,131.5 C 116.707,155.232 116.874,178.898 124,202.5C 136.061,229.447 156.561,239.781 185.5,233.5C 181.111,245.057 173.111,253.224 161.5,258C 157.667,259.034 154.001,260.2 150.5,261.5C 107.983,263.354 80.8161,244.021 69,203.5C 67.9641,196.201 67.4641,188.868 67.5,181.5C 86.1299,164.706 104.63,147.706 123,130.5C 123.399,130.728 123.565,131.062 123.5,131.5 Z"/></g>
      <g><path  fill="#e1445b" d="M 215.5,132.5 C 221.529,133.365 224.529,136.865 224.5,143C 222.845,155.974 215.512,161.307 202.5,159C 195.962,156.301 192.295,151.468 191.5,144.5C 191.5,140.5 191.5,136.5 191.5,132.5C 199.5,132.5 207.5,132.5 215.5,132.5 Z"/></g>
      <g><path  fill="#0153a1" d="M 150.5,261.5 C 154.001,260.2 157.667,259.034 161.5,258C 173.111,253.224 181.111,245.057 185.5,233.5C 187.264,229.795 188.431,225.795 189,221.5C 189.699,213.482 189.532,205.482 188.5,197.5C 189.493,183 197.16,176.167 211.5,177C 224.791,181.402 229.958,190.569 227,204.5C 223.889,224.238 213.722,239.071 196.5,249C 182.068,256.534 166.735,260.7 150.5,261.5 Z"/></g>

      </svg>
    </Box>
  );

  if (disabledLink) {
    return logo;
  }

  return (
    <Link component={RouterLink} href="/" sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default Logo;
